import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import EnterpriseHero from "@/components/EnterpriseHero";
import EnterpriseFeatures from "@/components/EnterpriseFeatures";
import UseCases from "@/components/UseCases";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";
import SEO, { 
  organizationSchema, 
  homepageSchemas,
  createSpeakableSchema,
  navigationSchema 
} from "@/components/SEO";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to specific sections when navigating from other pages
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <SEO
        title="AI Bulk Image Generator - Create 1000+ Images/Hour Free | FLUX AI"
        description="Generate 1000+ stunning AI images per hour with FLUX.1. Free trial available. Perfect for e-commerce, marketing & creative teams. Start creating now!"
        keywords="ai image generator, bulk image generator, flux ai, ai product photography, batch image creation, ai image generation, flux model, mass image generation, ai images for business, commercial ai images, text to image bulk, ai image generator free, flux 1.1 pro, ai photo generator, generate images in bulk, ai art generator, product photo ai, ecommerce image generator, marketing image ai, ai visual content, best ai image generator 2026"
        url="/"
        jsonLd={[
          ...homepageSchemas,
          createSpeakableSchema('/', ['.speakable-title', '.speakable-description']),
        ]}
      />
      <div className="w-full">
        <Header />
        <main className="w-full">
          <EnterpriseHero />
          <EnterpriseFeatures />
          <UseCases />
          <HowItWorks />
          <Pricing />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Index;
